import { createRouter as createTanStackRouter } from "@tanstack/solid-router";
import { getContext } from "./integrations/tanstack-query/provider";
import type { AuthContextValue } from "./lib/auth";
import { routeTree } from "./routeTree.gen";

export type RouterContext = {
  queryClient: ReturnType<typeof getContext>["queryClient"];
  auth: AuthContextValue;
};

export function getRouter() {
  const router = createTanStackRouter({
    routeTree,

    context: {
      ...getContext(),
      // auth is injected at render time via RouterProvider context prop
      auth: undefined as unknown as AuthContextValue,
    },

    scrollRestoration: true,
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
  });

  return router;
}

declare module "@tanstack/solid-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
